import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../authentication/services/authentication.service';
import { Constants } from '../common/helper/constants';
import { NavigationEnd, Router } from '@angular/router';
import { GlobalObservables } from '../../app.global.observer';
import { Global } from '../../app.global';
import { AlertModel } from '../common/viewmodels/alert.model';
import { AlertsService } from '../common/services/alerts.service';
import { bounceBubbleAnimation, slideToggle } from '../../app.animations';
import {
  SubscriptionLike as ISubscription,
  Observable,
  Subject,
  Subscription,
  merge,
  of,
} from 'rxjs';
import { catchError, concatMap, debounceTime, startWith, tap } from 'rxjs/operators';
import { SettingsService } from '../../authentication/services/settings.service';

@Component({
  selector: 'app-header-cmp',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [bounceBubbleAnimation, slideToggle],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('alertsPanel') alertsPanel: ElementRef;
  // @ViewChild('debugConsole', { static: true }) private debugConsole: ElementRef;

  public constants = Constants;
  public firstName = '';
  public routeUrl = '';
  public isNavOpen = false;
  isAlertsVisible = false;
  isCustomLettersVisible = false;
  isCustomParagraphsVisible = false;
  alerts: Array<AlertModel> = [];
  customLetters: Array<AlertModel> = [];
  customParagraphs: Array<AlertModel> = [];
  bounceAlertsBubbleState: any = 1;
  bounceLettersBubbleState: any = 1;
  hasUserReportsAccess = false;
  hasUserAdminAccess = false;
  isAdminPage = false;
  isReportsPage = false;
  isProfileMenuVisible = false;
  isConsoleVisible = false;
  showAccountSettings = false;
  // isDebugConsoleEnabled = false;
  codeErrors = [];

  private onCodeErrorSubscription: ISubscription;
  private alertRefresh: Subscription;

  /** Manual refresh requests, queued alongside the event-driven ones. */
  private readonly alertRefreshRequested = new Subject<void>();

  constructor(
    public authService: AuthenticationService,
    public globalObs: GlobalObservables,
    public global: Global,
    public alertsService: AlertsService,
    public router: Router,
    private authenticationService: AuthenticationService,
    private _eref: ElementRef,
    private settingsService: SettingsService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.routeUrl = event.url;
      }
    });
  }

  ngOnInit() {
    /* Setup Observables / Events */
    //
    // One queue for every alert refresh, including the initial load.
    //
    // Saving a PCN emits onPcnChanged and then, on the next line, resetReasons
    // emits onReasonsChanged - both plain Subjects, so both arrive in the same
    // tick and each used to start its own set of alert requests. debounceTime
    // collapses that pair into one refresh; concatMap holds any later trigger
    // until the current one has finished, so two chains are never in flight.
    //
    // concatMap rather than switchMap deliberately: unsubscribing an in-flight
    // request only abandons the response, and the server has already written
    // the decision-flow state by then - so cancelling would not prevent a stale
    // write landing after a newer one.
    //
    // startWith puts the first load through the same queue. Subscribing to it
    // separately would let it overlap with a refresh triggered milliseconds
    // later, which is the problem this exists to remove.
    this.alertRefresh = merge(
      this.globalObs.onPcnChanged,
      this.globalObs.onReasonsChanged,
      this.globalObs.onDocumentsChanged,
      this.alertRefreshRequested
    )
      .pipe(
        startWith(null),
        debounceTime(0),
        concatMap(() => this.loadAlertData())
      )
      .subscribe();

    this.onErrorRequest();
    // this.scrollDebugConsole();
    this.getCurrentUser();
    this.checkAdminPage();
    this.checkReportsPage();
    // this.onPcnChange();

    this.onDocumentsChange();
    this.loadAccountSettingsFlag();

    this.hasUserAdminAccess = this.authenticationService.hasAdminAccess();
    this.hasUserReportsAccess = this.authenticationService.hasReportsAccess();

    // set debug console
    // this.isConsoleVisible = this.settingsService.getLocalDebugConsole();
  }

  toggleProfileMenu(event: MouseEvent): void {
    event.stopPropagation(); // so any parent click handlers don’t fire
    this.isProfileMenuVisible = !this.isProfileMenuVisible;
  }

  setAlerts() {
    if (
      this.global.PCN === null ||
      this.global.PCN.pcn === undefined ||
      this.global.PCN.pcn === ''
    ) {
      this.alerts = [];
      this.global.alerts = [];
      return;
    }
    this.alertsService.getAlerts(this.global.PCN.pcn).subscribe((result) => {
      if (result) {
        this.alerts = [];
        result.forEach((alert) => {
          alert.selected = false;
        });
        this.alerts = result;
        this.bounceAlertsBubbleState = Math.random();
        this.global.alerts = this.alerts;
      }
    });
  }

  getCurrentUser() {
    const currentUser = this.authService.getCurrentUser();
    this.firstName = currentUser.firstName;
  }

  puzzleIconClicked() {
    /// *if */(this.routeUrl !== '/reasons') //{
    this.router.navigate(['/reasons']);
    // } else {
    //  this.isCustomLettersVisible = !this.isCustomLettersVisible;
    //  this.globalObs.onCustomLettersShow.next({ 'visibility': this.isCustomLettersVisible });
    // if (!this.isCustomLettersVisible) {
    //  console.log('here');
    //  this.globalObs.afterReasonSetted.next(truenode_modules/primeicons/primeicons.css);
    // }
    // }
  }

  showBackButton() {
    return this.isPcnProcessing() && this.routeUrl !== '/reasons';
  }

  isPcnProcessing() {
    return this.global.isPcnProcessing;
  }

  backToLetter() {
    this.router.navigate(['/reasons']);
  }

  toggleNav(): void {
    this.isNavOpen = !this.isNavOpen;
  }

  setSelectedCustomParagraphs() {
    this.alertsService.getSelectedAlerts().subscribe((result) => {
      if (result) {
        const selectedAlertsIds = [];
        result.forEach((alert) => {
          selectedAlertsIds.push(alert.id);
        });
        this.customParagraphs.forEach((paragraph) => {
          paragraph.selected = selectedAlertsIds.indexOf(paragraph.id) > -1;
          // || paragraph.paragraphAutoSelect.value;
        });
      }
    });
  }

  checkAdminPage() {
    this.isAdminPage = this.routeUrl.indexOf('/admin') > -1;
  }

  checkReportsPage() {
    this.isReportsPage = this.routeUrl.indexOf('/reports') > -1;
  }

  onPcnChanged() {
    // this.setAlerts();
    // this.setCustomLetters();
    // this.setCustomParagraphs();
    this.setData();
  }

  // onReasonsChange() {
  //   this.globalObs.afterReasonSaved.subscribe(() => {
  //     this.setAlerts();
  //     this.setCustomLetters();
  //   });
  // }

  onReasonsChanged() {
    // this.setAlerts();
    // this.setCustomLetters();
    // this.setCustomParagraphs();
    this.setData();
  }

  onDocumentsChange() {
    // this.globalObs.onDocumentsChanged.subscribe(() => {
    // });
  }

  /** Request an alert refresh. Always goes through the serialised queue. */
  setData() {
    this.alertRefreshRequested.next();
  }

  toggleAlertsPanel() {
    this.isAlertsVisible = !this.isAlertsVisible;
    this.alerts.forEach((alert) => (alert.selected = false));
  }

  // switchConsole() {
  //   this.isConsoleVisible = !this.isConsoleVisible;
  //   this.settingsService.setLocalDebugConsole(this.isConsoleVisible);
  // }

  openProfileMenu() {
    this.isProfileMenuVisible = !this.isProfileMenuVisible;
    // this.isDebugConsoleEnabled = this.global.appSettings['Configuration.EnableDebugConsole'];
    // this.settingsService.getApplicationSetting("Configuration.EnableDebugConsole")
    // .subscribe(
    //   result =>{
    //     this.isDebugConsoleEnabled = result;
    //   }
    // )
    // .catch(() => {
    //   this.isDebugConsoleEnabled = false;
    // });
  }

  loadAccountSettingsFlag(): void {
    this.settingsService.getApplicationSetting('EnableAccountSettings').subscribe((value) => {
      this.showAccountSettings = value === true || value === 'true';
    });
  }

  // isDebugConsoleVisible() {
  //   // const isDebugConsoleEnabled = this.global.appSettings['Configuration.EnableDebugConsole'];
  //   const isDebugConsoleEnabled = false;
  //   // this.settingsService.getApplicationSetting("Configuration.EnableDebugConsole")
  //   // .subscribe(
  //   //   result =>{
  //   //     isDebugConsoleEnabled = result;
  //   //   }
  //   // )
  //   // .catch(() => {
  //   //   isDebugConsoleEnabled = false;
  //   // });
  //   return isDebugConsoleEnabled && this.isConsoleVisible;
  // }

  onErrorRequest() {
    this.onCodeErrorSubscription = this.globalObs.pushError.subscribe((result) => {
      this.global.codeErrors.push(result);
      this.global.codeErrors = this.global.codeErrors;
      this.codeErrors = this.global.codeErrors;
      // if (this.isDebugConsoleVisible()) {
      //   this.scrollDebugConsole();
      // }
    });
  }

  // scrollDebugConsole(): void {
  //   try {
  //     setTimeout(() => {
  //       this.debugConsole.nativeElement.scrollTop = this.debugConsole.nativeElement.scrollHeight;
  //     }, 20);
  //   } catch (err) { }
  // }

  changePassword() {}

  logout() {
    this.authenticationService.logoutAccount().subscribe(
      (result) => this.authenticationService.logout(),
      (err) => console.log(err)
    );
  }

  onDocumentClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.isProfileMenuVisible = false;
    }
    if (!this.alertsPanel.nativeElement.contains(event.target)) {
      this.isAlertsVisible = false;
      this.alerts.forEach((alert) => (alert.selected = false));
    }
  }

  ngOnDestroy() {
    this.onCodeErrorSubscription?.unsubscribe();
    this.alertRefresh?.unsubscribe();
  }
  /**
   * Loads the custom letters, then the custom paragraphs.
   *
   * The order matters on the server. `getCustomLetters` seeds AcceptedAlerts
   * the first time a case asks for it and does nothing thereafter;
   * `getCustomParagraphs` adds its auto-selected ids to whatever is already
   * there. Run concurrently, each computed its answer from the same starting
   * state and the later commit discarded the earlier one - measured on the dev
   * slot as five lost updates on AcceptedAlerts per three-case session.
   *
   * The two legs catch their own errors. They were independent subscriptions
   * before, so a failure to load letters never stopped paragraphs loading, and
   * chaining them must not introduce that dependency. Catching inside also
   * keeps the outer refresh stream alive for the next trigger.
   */
  private loadAlertData(): Observable<unknown> {
    // Read-only endpoint, and not part of the ordering problem.
    this.setAlerts();

    const pcn = this.global.PCN?.pcn;

    if (!pcn) {
      this.customLetters = [];
      this.global.customLetters = [];
      this.globalObs.onCustomLettersChanged.next(true);

      return of(null);
    }

    return this.alertsService.getCustomLetters(pcn).pipe(
      tap((result) => this.publishCustomLetters(result)),
      catchError(() => of(null)),
      concatMap(() =>
        this.alertsService.getCustomParagraphs(pcn).pipe(
          tap((result) => this.publishCustomParagraphs(result)),
          catchError(() => of(null))
        )
      )
    );
  }

  private publishCustomLetters(result) {
    if (!result) {
      return;
    }

    this.customLetters = [];
    result.forEach((customLetter) => {
      customLetter.decisionName = 'Uphold';
      customLetter.selected = false;
      if (customLetter.decisionId === 2) {
        customLetter.decisionName = 'Cancel';
      } else if (customLetter.decisionId === 3) {
        customLetter.decisionName = 'Req Info';
      }
    });
    this.customLetters = result;
    this.global.customLetters = this.customLetters;
    this.globalObs.onCustomLettersChanged.next(true);
  }

  private publishCustomParagraphs(result) {
    if (!result) {
      return;
    }

    this.customParagraphs = [];
    result.forEach((customParagraph) => {
      customParagraph.selected = false;
    });
    this.customParagraphs = result;
    this.global.customParagraphs = this.customParagraphs;
    this.globalObs.onCustomParagraphsChanged.next(true);
  }
}
